import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { certificateImageUrl } from '../general/certificates';
import { Api } from '../general/api';

function PublicCertificate({ certificateKey }: { certificateKey: string }) {
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const [status, setStatus] = useState<{ status: 'ready' | 'pending_name'; course_name: string } | null>(null);

    useEffect(() => {
        const controller = new AbortController();
        Api.getPublicCertificateStatus(certificateKey, controller.signal).then(result => {
            if (!controller.signal.aborted) {
                setStatus(result);
                if (result.status === 'pending_name') setLoading(false);
            }
        }).catch(() => {
            if (!controller.signal.aborted) { setLoading(false); setFailed(true); }
        });
        return () => controller.abort();
    }, [certificateKey, attempt]);

    return <>
        {loading && <p role="status">Loading certificate…</p>}
        {status?.status === 'pending_name' ? <div role="alert">
            <p>We confirm that the certificate holder has completed <strong>{status.course_name}</strong>. However, they have not yet confirmed the name to appear on their certificate, so we cannot generate it at this time.</p>
            <Button label="Try again" onClick={() => { setStatus(null); setLoading(true); setAttempt(value => value + 1); }} />
        </div> : failed ? <div role="alert">
            <p>This certificate is unavailable. The link may be invalid, the certificate may have been withdrawn, or it could not be loaded.</p>
            <Button label="Try again" onClick={() => { setFailed(false); setStatus(null); setLoading(true); setAttempt(value => value + 1); }} />
        </div> : status?.status === 'ready' && <img key={attempt} src={certificateImageUrl(certificateKey)} alt="Certificate of completion"
            style={{ width: '100%', maxHeight: 'calc(100dvh - 200px)', objectFit: 'contain', visibility: loading ? 'hidden' : 'visible' }}
            onLoad={() => setLoading(false)} onError={() => { setLoading(false); setFailed(true); }} />}
    </>;
}

/** Public by possession of the certificate key; no account or API context needed. */
export default function CertificatePage() {
    const { key } = useParams<{ key: string }>();
    const valid = key && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(key);
    return <section className="w-full overflow-auto">
        <h1 className="mt-0">Certificate of completion</h1>
        {valid ? <PublicCertificate key={key} certificateKey={key} /> : <p role="alert">This certificate link is invalid.</p>}
    </section>;
}
